import { matchBooleanQuery, parseBooleanQuery } from './boolean-query.mjs';

// Een Boolean-expressie geldt voor het hele record: AND mag verschillende
// velden raken. Gewone invoer houdt de bestaande deeltekstzoeker per veld.
export function matchesSearchText(raw, values) {
  const parts = (Array.isArray(values) ? values : [values]).map((v) => String(v ?? ''));
  if (parseBooleanQuery(raw).isBoolean) return matchBooleanQuery(raw, parts.join(' '));
  const needle = String(raw ?? '').trim().toLocaleLowerCase('nl-NL');
  return parts.some((value) => value.toLocaleLowerCase('nl-NL').includes(needle));
}
